import { Component, OnInit } from '@angular/core';
import { NgbCalendar, NgbDate, NgbPeriod } from '@ng-bootstrap/ng-bootstrap';
import { DateSelectService } from '../../services/date-select.service';
import { ReachService } from 'src/app/services/reach.service';
import { LoginService } from '../../services/login.service';
import { Observable } from 'rxjs';
import { NgbPopoverWindow } from '@ng-bootstrap/ng-bootstrap/popover/popover';


@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit {

  // Apply today's date to datepicker
  model = this.calendar.getToday();
  pwap = this.calendar.getToday();
  dateIncrementStatus = { canIncrement: false, canDecrement: true };
  tempDate: Date = new Date();
  private minDate: NgbDate = new NgbDate(2019, 7, 1);
  private today: Date = new Date();
  private todayng: NgbDate = new NgbDate(this.today.getFullYear(), this.today.getMonth() + 1, this.today.getDate());
  //private maxDate: NgbDate = new NgbDate(this.today.getFullYear(), this.today.getMonth() + 1, this.today.getDate());
  private maxDate: NgbDate = this.calendar.getPrev(this.todayng, 'd', 1);

  authenticated: Observable<boolean>;

  constructor(
    private dateObject: DateSelectService,
    private reachService: ReachService,
    private calendar: NgbCalendar,
    private loginService: LoginService) {
      this.authenticated = loginService.authenticated;
  }

  ngOnInit() {
    this.maxDate = this.calendar.getPrev(this.todayng, 'd', 1);
    this.dateObject.currentDate.subscribe((result) => {
      this.model.month = parseInt(result.slice(5,7));
      this.model.day = parseInt(result.slice(8,10));
      this.model.year = parseInt(result.slice(0,4));
      
      this.pwap = this.calendar.getPrev(this.model, 'd', 1);
      this.updateTempDate();
    });

    this.reachService.getStations();
  }

  // Sends formatted 'YYYY-MM-DD' date string to DateService
  sendDate() {
    this.updateTempDate();
    let day = this.model.day.toString();
    if ( this.model.day < 10 ) { day = '0' + day }
    let month = this.model.month.toString();
    if ( this.model.month < 10 ) { month = '0' + month }
    let dateString:string = this.model.year + '-' + month + '-' + day;
    this.dateObject.changeDate(dateString);
  }

  sendDateFromPwap() {
    this.model = this.calendar.getNext(this.pwap, 'd', 1);
    this.sendDate();
  }
  
  // Updates the JavaScript Date Object version of the date when the model changes
  updateTempDate() {
    this.tempDate = new Date(this.model.year, this.model.month - 1, this.model.day);
  }

  // Updates the ngBootstrap model version of the date when the JS Date Object version changes
  updateModel() {
    this.model.day = this.tempDate.getDate();
    this.model.month = this.tempDate.getMonth() + 1;
    this.model.year = this.tempDate.getFullYear();
  }

  // Function to increment/decrement the date by one day
  changeDay(x) {
    let localPwap = this.calendar.getToday();
    localPwap.year = this.pwap.year; localPwap.month = this.pwap.month; localPwap.day = this.pwap.day + x;
    if (localPwap.equals(this.maxDate)) {
      this.dateIncrementStatus.canIncrement = false;
      this.dateIncrementStatus.canDecrement = true;
    }
    else if (localPwap.equals(this.minDate)) {
      this.dateIncrementStatus.canIncrement = true;
      this.dateIncrementStatus.canDecrement = false;
    } else {
      this.dateIncrementStatus.canIncrement = true;
      this.dateIncrementStatus.canDecrement = true;
    }
    // Check to see if date is already at min or max and if so flag so we can disable buttons
    if (this.pwap.year === this.maxDate.year && this.pwap.month === this.maxDate.month && this.pwap.day === this.maxDate.day && x > 0) {}
    else if (this.pwap.year === this.minDate.year && this.pwap.month === this.minDate.month && this.pwap.day === this.minDate.day && x < 0) {}
    else {
      this.tempDate.setDate(this.tempDate.getDate() + x);
      this.updateModel();
      this.sendDate();  
    }
  }
}
